import Reconoce from '@/views/intranet/reconoce/Reconoce.vue'
import FormReconoceView from '@/views/intranet/reconoce/FormReconoceView.vue'

export const reconoce = {
  path: '/reconoce',
  name: 'Reconoce',
  component: Reconoce,
  meta: { requiresAuth: true }
}

export const formReconoceView = {
  path: '/nuevo-reconocimiento',
  name: 'FormReconoceView',
  component: FormReconoceView,
  meta: { requiresAuth: true }
}

export const reconoceId = {
  path: '/reconoce/:id',
  name: 'ReconoceId',
  props: true,
  component: Reconoce,
  meta: { requiresAuth: true }
}